import { RecurrentTask, RecurrentTaskInput } from '../models/recurrent-task.model';

export abstract class RecurrentTasksRepository {
  abstract getRecurrentTasks(): Promise<RecurrentTask[]>;
  abstract getRecurrentTaskSummaries(): Promise<RecurrentTask[]>;
  abstract getRecurrentTaskDetails(definitionId: number): Promise<RecurrentTask>;
  abstract createRecurrentTask(input: RecurrentTaskInput): Promise<void>;
  abstract updateRecurrentTask(task: RecurrentTask, input: RecurrentTaskInput): Promise<void>;
  abstract planOccurrence(definitionId: number, scheduledFor: string): Promise<void>;
  abstract completeOccurrence(
    occurrenceId: number,
    completedOn: string,
    createNext: boolean,
    nextScheduledFor: string | null
  ): Promise<void>;
  abstract reopenOccurrence(occurrenceId: number): Promise<void>;
  abstract cancelOccurrence(
    occurrenceId: number,
    reason: string | null,
    createNext: boolean,
    nextScheduledFor: string | null
  ): Promise<void>;
  abstract rescheduleOccurrence(occurrenceId: number, scheduledFor: string): Promise<void>;
  abstract applyAutomaticRollover(today: string): Promise<void>;
  abstract deactivateDefinition(definitionId: number): Promise<void>;
  abstract reactivateDefinition(definitionId: number, firstScheduledFor: string | null): Promise<void>;
  abstract setSubtaskCompleted(subtaskId: number, completed: boolean): Promise<void>;
  abstract updateHistoricalOccurrence(
    occurrenceId: number,
    status: 'COMPLETED' | 'CANCELLED',
    completedOn: string | null,
    cancellationReason: string | null,
    recalculateNext: boolean
  ): Promise<void>;
  abstract deleteOccurrence(occurrenceId: number): Promise<void>;
  abstract deleteSuspendedTask(definitionId: number): Promise<void>;
}
